// extracted by mini-css-extract-plugin
export default {"gallery":"styles_gallery__o4BkF","price":"styles_price__32AQP"};